import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Usuario from './models/usuarios/usuario.model';
import * as signalR from "@aspnet/signalr";
import {
  clearAllSessionData,
  clearLegacyPersistentSession,
  getSessionToken,
  getSessionUser,
  setSessionToken,
  setSessionUser
} from "@/helpers/sessionStorage";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    editingEntity: null,
    sidebarActive: true,
    isMobile: window.innerWidth < 1088,
    showSectionLogout: false,
    showNavbarInMobile: true,
    status: "",
    token: getSessionToken(),
    user: getSessionUser({}),
    alertasHogar:0,
    loadingAlertasHogar:false,
    hubConnection: null,
    tieneHogar:false,
    nuevaCedulaParaConsulta: ""
  },
  mutations: {
    setIsMobile(state, value) {
      state.isMobile = value;
    },
    setuser(state, user) {
      state.user = user;
    },
    setSidebarActive(state, value) {
      state.sidebarActive = value;
    },
    setEditEntity(state, payload) {
      state.editingEntity = payload;
    },
    toggleshowSectionLogout(state, value) {
      state.showSectionLogout = value
    },
    toggleShowNavbarInMobile(state, value) {
      state.showNavbarInMobile = value
    },
    setAlertasHogar(state, value) {
      state.alertasHogar = value;
    },
    setLoadingAlertasHogar(state, value) {
      state.loadingAlertasHogar = value;
    },
    setTieneHogar(state, value) {
      state.tieneHogar = value;
    },
    setNuevaCedulaParaConsulta(state, value) {
      state.nuevaCedulaParaConsulta = value;
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, { token, user}) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    auth_error(state) {
      state.status = "error";
      state.token = "";
      state.user = {};
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");

        //var action = user.tarjeta ? "requestBeneficiarioWithTarjeta": "requestBeneficiario"

/*         axios({
          url: process.env.VUE_APP_API_URL + "authentication/" + action,
          data: user,
          method: "POST"
        }) */

        axios({
          url: process.env.VUE_APP_API_URL + "authentication/" + "requestBeneficiario",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = resp.data.token;
            const user = resp.data.user;
            setSessionToken(token);
            setSessionUser(user);
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", { token, user});
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            clearAllSessionData();
            delete axios.defaults.headers.common["Authorization"];
            reject(err);
          });
      });
    },
    async logout({ commit, getters }) {
      try {
        await getters.hubConnection.stop();
      } catch (err) {
      }

        commit("logout");
        clearAllSessionData();
        clearLegacyPersistentSession();
        delete axios.defaults.headers.common["Authorization"];
    },
    mobileShowSectionLogout(context, value) {
      context.commit('toggleshowSectionLogout', value);
    },
    mobileShowNavbarInMobile(context, value) {
      context.commit('toggleShowNavbarInMobile', value);
    },
  },
  getters : {
    isMobile: state => state.isMobile,
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    hubConnection: (state) => {
      if (!state.hubConnection) {
        state.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(process.env.VUE_APP_BASE_API_URL + "hub", {
            accessTokenFactory: () => state.token
          })
          .build();
      }
      return state.hubConnection;
    }
  }
});
